export const NODE_WIDTH = 112
export const NODE_HEIGHT = 192

export const DETECTION_DISTANCE_X = NODE_WIDTH * 0.8
export const DETECTION_DISTANCE_Y = NODE_HEIGHT * 0.8

export const DEFAULT_PIPELINE_WORKFLOW_NAME = 'New Pipeline'
export const SYSTEM_USER = 'SYS'

export const MAX_TRANSFORMATION_STEPS = 10
